export enum CardTypeEnum {
  Active,
  Previous,
}

export type CardType = CardTypeEnum.Active | CardTypeEnum.Previous;
